<template>
    <div>
        <h1>Service Fees List</h1>
    </div>
</template>

<script>
    export default {
        name: 'ServiceFees'
    };
</script>
